import { AuthProvider } from '@/auth/providers/auth.provider';
import axios from 'axios';

class AuthenticatedFileDownloadProviderClass {
  public async download(url: string, fallbackFileName: string = 'download'): Promise<void> {
    const token = AuthProvider.getToken();
    if (!token) {
      throw new Error('Authentication is required to download this file');
    }

    const response = await axios.get(url, {
      headers: { Authorization: `Bearer ${token}` },
      responseType: 'blob'
    });
    const contentDisposition = response.headers && response.headers['content-disposition'];
    const match = contentDisposition && contentDisposition.match(/filename\*?=(?:UTF-8''|["']?)([^"';]+)/i);
    const fileName = match ? decodeURIComponent(match[1]) : fallbackFileName;
    const objectUrl = URL.createObjectURL(response.data);
    const anchor = document.createElement('a');
    anchor.href = objectUrl;
    anchor.download = fileName;
    anchor.style.display = 'none';
    document.body.appendChild(anchor);
    anchor.click();
    setTimeout(() => {
      document.body.removeChild(anchor);
      URL.revokeObjectURL(objectUrl);
    }, 100);
  }
}

export const AuthenticatedFileDownloadProvider = new AuthenticatedFileDownloadProviderClass();
